import { render, staticRenderFns } from "./tmVisualBadge.vue?vue&type=template&id=25312fbf&"
import script from "./tmVisualBadge.vue?vue&type=script&lang=js&"
export * from "./tmVisualBadge.vue?vue&type=script&lang=js&"
import style0 from "./tmVisualBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports